import ContentLoader from "react-content-loader";
import { HorizontalContainer } from "../layout/horizontal-container";
import { PageContent } from "../layout/page-content";
import { RegisterButtonSkeleton } from "../skeletons/register-button-skeleton";

export const BoxesLoader = () => (
  <HorizontalContainer horizontalPlacement="center">
    <RegisterButtonSkeleton length={3} size="large" />
    <RegisterButtonSkeleton length={3} size="large" />
    <RegisterButtonSkeleton length={3} size="large" />
  </HorizontalContainer>
);

export const SmallBoxesLoader = () => (
  <PageContent width="medium">
    <HorizontalContainer horizontalPlacement="center">
      <ContentLoader viewBox="0 0 240 50" height={50} width={240}>
        <rect rx="8" ry="8" width="240" height="34" />
      </ContentLoader>
    </HorizontalContainer>
    <HorizontalContainer horizontalPlacement="center">
      <RegisterButtonSkeleton length={8} size="small" />
      <RegisterButtonSkeleton length={8} size="small" />
      <RegisterButtonSkeleton length={8} size="small" />
      <RegisterButtonSkeleton length={8} size="small" />
      <RegisterButtonSkeleton length={8} size="small" />
      <RegisterButtonSkeleton length={8} size="small" />
      <RegisterButtonSkeleton length={8} size="small" />
      <RegisterButtonSkeleton length={8} size="small" />
    </HorizontalContainer>
  </PageContent>
);
